import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import { useParams } from 'react-router-dom';
import api from '../../utils/api';
import CreateInstitution from './Create';

const EditInstitution = (props) => {
   const { id } = useParams();
   const [institution, setInstitution] = useState(null);
   const [loading, setLoading] = useState(true);

   useEffect(() => {
       props.setBreadcrumbItems('تعديل مؤسسة', [
           { title: "الرئيسية", link: "/dashboard" },
           { title: "المؤسسات", link: "/dashboard/institutions" },
           { title: "تعديل مؤسسة", link: "#" }
       ]);
       fetchInstitution();
   }, []);

   const fetchInstitution = async () => {
       try {
           const response = await api.get(`/institutions/${id}`);
           setInstitution(response.data.data);
       } catch (error) {
           console.error('Error fetching institution:', error);
       } finally {
           setLoading(false);
       }
   };

   if (loading) return <p>جاري تحميل بيانات المؤسسة...</p>;
   if (!institution) return <p>لم يتم العثور على المؤسسة.</p>;

   return (
       <CreateInstitution mode="edit" institutionData={institution} />
   );
};

export default connect(null, { setBreadcrumbItems })(EditInstitution);